import React, { useEffect, useState } from 'react';
import './UnitsSettingsStyle.css';
import { UnitModel } from '../model/UnitsModel';
import { useNavigate } from 'react-router-dom';
import { AiFillDelete} from "react-icons/ai";

interface Props{
    loggedState: number;
    loggedID: String;
}

const Cars = ({loggedState,loggedID}:Props) => {
  const [emCars,setEmCars] = useState<UnitModel[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const navigate = useNavigate();
    
    const back = () => {
        navigate("/MainPage");
    };
    
  useEffect(() => {
    ReadUnits(loggedID);
  }, []);

  const filteredCars = emCars.filter(car => 
    car.Unit.toLowerCase().includes(searchTerm.toLowerCase()) // Filter nach Name
  );

  const ReadUnits = async (loginID:String) => {
    try {
      //console.log('loggedID:',loginID);
      const transferCheckSum = 'xz5h4z3o';
      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/ReadUnits.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          transferCheckSum,
          loginID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        //console.log('Cars vorhanden:', data);
        setEmCars(data);
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen der Cars:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
  };
  

  const updateName = (id:number, field:string, value:string) => {
    setEmCars((prevCars) =>
      prevCars.map((car) =>
        car.ID === id
          ? { ...car, [field]: value } // Update das Feld (activeMember oder agt)
          : car
      )
    );
  };

  const handleNameChange = async (unitID:String, value:String) => {
    const column = 'Unit'
    try {
      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/UpdateUnit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //Einsatz => em_Einsätze 
          unitID,
          column,
          value,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          ReadUnits(loggedID);
        }
        else{
          alert("Einheit konnte nicht aktualisiert werden");
        }
          
      } else {
        const data = await response.json();
        alert("Einheit konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   
  };

  const deleteCar = async (ID:number) => {
    try {
        const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/DeleteUnit.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ID,
          }),
        });
  
        if (response.ok) {
          const data = await response.json();
          // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
          if(data.status === 'success'){
            alert("Einheit wurde gelöscht");
            ReadUnits(loggedID)
          }
          else{
            alert("Einheit konnte gelöscht werden werden");
          }
            
        } else {
          const data = await response.json();
          console.error('Fehler beim lesen des Einsatz:', response.statusText);
          alert("Einheit konnte nicht aktualisiert werden");
        }
      } catch (error) {
        console.error('Fehler beim Request:', error);
      }   

};

const carAdd = async (loginID:String) => {
  try {
      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/AddUnit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          loginID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          alert("Einheit wurde angelegt");
          ReadUnits(loggedID)
        }
        else{
          alert("Einheit konnte nicht angelegt werden");
        }
          
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Einheit konnte nicht angelegt werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   

};

const AddCar = () => {
  carAdd(loggedID)
  
};

const DeleteCar = (id:number) => {
  deleteCar(id)
};

  return (
    <div className="App" style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}>
      <div className="search-box-container">
            <div className="header">
                <h2>Einheiten-Verwaltung</h2>
                <button className="new-button" onClick={() => AddCar()}>Neue Einheit</button>
            </div>
            <div className="search-box">
                <label htmlFor="search">Suche:</label>
                <input 
                  type="text" 
                  id="search"  
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)} // Überwachen der Eingabe
                />
            </div>
        </div>


      <table className="table">
        <thead className="table-header">
        <tr>
          <th className="col-1">Einheit</th>
          <th className="col-2"></th>
        </tr>
      </thead>
      <tbody>
        {filteredCars.map((row) => (
          <tr key={row.ID}>
              <td className="col-1">
                <input
                  type="text"
                  value={row.Unit}
                  onChange={(e) => updateName(row.ID,'Unit', e.target.value)}
                  onBlur={(e) => handleNameChange(String(row.ID), String(e.target.value))} // Aktualisiere den Namen
                />
              </td>
              <td className="col-2">
                <span className='icon' onClick={()=> DeleteCar(row.ID)}>
                    <AiFillDelete></AiFillDelete>
                </span>
              </td>
          </tr>
        ))}
      </tbody>
    </table>
      

    </div>
  );
}

export default Cars;
